/**
 * 코드 표기값을 만든다.
 * 저장값은 항상 접미사가 없는 원본 코드이고, 원산지 제한이 있을 때만 화면과 서류에 접미사를 붙인다.
 * 접미사는 공통코드 값(N1, N2 ...) 그 자체라 값이 늘어도 이 함수는 그대로다.
 */
export function withOriginLimit(code, originLimitCode) {
  if (!code) return '';
  return originLimitCode ? `${code}-${originLimitCode}` : code;
}

/** 원산지 제한 공통코드의 그룹키 */
export const ORIGIN_LIMIT_CODE_GROUP = 'OR';

/** 드롭다운 첫 항목. 범용은 공통코드에 등록하지 않고 화면에서만 만든다(접미사 없음). */
export const ORIGIN_LIMIT_NONE = { value: '', label: '범용' };

/**
 * 조회 결과 한 건에서 표기값을 꺼낸다.
 * 쿼리가 display_code 를 내려줬으면 그대로 쓰고, 없으면 code + origin_limit_code 로 만든다.
 */
export function displayCodeOf(row, code) {
  if (row && row.display_code) return row.display_code;
  const raw = code !== undefined && code !== null ? code : row && row.code;
  return withOriginLimit(raw, row && row.origin_limit_code);
}
